import styles from './NavFooter.module.scss';
import { AnimatePresence, motion } from 'motion/react';

interface NavFooterProps {
  showBorder: boolean;
  display?: boolean;
}

const NavFooter: React.FC<React.PropsWithChildren<NavFooterProps>> = ({
  children,
  showBorder,
  display = true,
}) => {
  return (
    <AnimatePresence initial={false}>
      {display && (
        <motion.div
          className={styles['nav-footer-container']}
          data-show-border={showBorder}
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: {
              delay: 0.2,
              duration: 0.2,
            },
          }}
          exit={{
            opacity: 0,
            transition: {
              duration: 0,
            },
          }}
        >
          <div>{children}</div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export { NavFooter };
